import { useContext } from "react";
import { VersionCheckContext, VersionCheckContextType } from "./VersionCheckContext";

export const useVersionCheck = (): VersionCheckContextType => {
  const context = useContext(VersionCheckContext);
  if (context === undefined) {
    throw new Error("useVersionCheck must be used within a VersionCheckProvider");
  }
  return context;
};
